import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import {
  FetchReviewSurveyDetailsRequest
} from "../../core/questionnaires.actions";
import {fetchReviewSurveyDetails} from "../../core/questionnaires.selectors";
import {
  SurveyReviewDetails
} from "../../models/fetch-questionnaires-list.model";
import {CommonService} from "../../../../shared/services/common.service";

@Component({
  selector: 'app-survey-review-screen',
  templateUrl: './survey-review-screen.component.html',
  styleUrls: ['./survey-review-screen.component.css']
})
export class SurveyReviewScreenComponent implements OnInit, OnDestroy {
  surveyDetails: SurveyReviewDetails;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    private commonService: CommonService
    ) {
  }


  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.onDestroy))
      .subscribe((params: any) => {
        if (params?.params?.questionnaireId) {
          this.store.dispatch(FetchReviewSurveyDetailsRequest({payload: {surveyId: params?.params?.questionnaireId}}))
        }
      });
    this.store.select(fetchReviewSurveyDetails).pipe(
      takeUntil(this.onDestroy)
    ).subscribe((reviewDetails: any) => {
      this.surveyDetails = reviewDetails.surveyReviewDetails
    });

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });
  }

  backButtonClicked() {
    const urlPrefix = this.router.url.split('/')[1];
    this.router.navigate([`/${urlPrefix}/questionnaires/my-questionnaires`])
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
